module.exports = __webpack_public_path__ + "static/bike-self-f1516bab5e4eaa739f1bbdeabad327bb.jpg";